module.exports = __webpack_public_path__ + "static/img/g36.4c5157c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/jx/g36.png
// module id = zaK+
// module chunks = 0